import * as OvationsApi from 'core/ovations-api';
import { RewardPackageType, RewardStatus } from 'core/ovations-api/enums';
import { mockStaticRewardCalculation } from './promotion';

export const mockRewardStatusHistories: OvationsApi.Types.RewardStatusHistory[] = [
    {
        date: `2018-09-20T20:00:08.734Z`,
        oldStatus: RewardStatus.Validated,
        newStatus: RewardStatus.Processed,
    },
];

export const mockReward: OvationsApi.Types.Reward = {
    rewardCalculation: mockStaticRewardCalculation,
    claimId: '-1',
    cardRewardDetail: null,
    status: OvationsApi.Enums.RewardStatus.Inactive,
    validatedAmount: 0,
    id: 1,
    rewardStatusHistory: mockRewardStatusHistories,
    rewardPackage: null,
    externalReference1: null,
    externalReference2: null,
    externalReference3: null,
};

export const mockCheckRewardDetail: OvationsApi.Types.CheckRewardDetail = {
    id: 'SomeString',
    checkNumber: 'A Check Number',
    status: RewardStatus.Replaced,
    amount: 0,
    updateDate: '',
    replacementIsPending: false,
    history: [],
    rewardPackageType: RewardPackageType.ReloadableUSA,
    rewardPackageName: null,
};
